export function OdaberiGrupu(grupaSifra:number,setOdabranaGrupa:any) {
    setOdabranaGrupa(grupaSifra);
}

